import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function GlowTransition() {
  const sectionRef = useRef<HTMLElement>(null);
  const brilhoRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.to(brilhoRef.current, {
        scaleY: 5,
        ease: "none",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 50%",
          end: "bottom 60%",
          scrub: true,
        },
      });
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="glow-transition">
      <div className="glow-content" />
      <div ref={brilhoRef} className="glow-brilho">
        <img
          src="https://i.postimg.cc/TwtJDjsH/Brilho-Verde-CSS-PACK.png"
          alt=""
          className="glow-img"
        />
      </div>
    </section>
  );
}
